import React, { useEffect } from "react";
import { useContext } from "react";
import { UserContext } from "../UserContext";

export function UserGuiding() {
  const { user } = useContext(UserContext);
  const tenantApi = user.getTenantApi();

  useEffect(() => {
    const fullName = user.getFullName();
    const email = user.getEmail();
    const isConvertedUser = user.isConvertedUser();
    const isSiaaAgency = user.isSiaaAgency() && !isConvertedUser;

    const tenant = user.getTenant();
    const tenantLevelUserId = user.getTenantLevelUserId();
    const identityProvider = user.getIdentityProvider();
    const sso = user.getSSO();
    const ssoSub = user.getSSOSub();
    const ssoCompany = user.getSSOCompany();
    const ssoAgencyId = user.getSSOAgencyId();
    const ssoExternalId = user.getSSOExternalID();
    const ssoEmailID = user.getSSOEmailID();
    const ssoRole = user.getSSORole();
    const isSSO = sso === true || sso === "true" ? true : false;

    window.userguidingRole = user.getTopRole();
    if (tenantApi) {
      window.userguidingPlanType = tenantApi.getPlanType();
    }

    let userId = `AgencyIQ-${ssoSub}`;
    if (isSiaaAgency && tenant && tenantLevelUserId) {
      userId = `AgencyIQ-${ssoSub}`;
      // userId = `AgencyIQ-${tenant}-${tenantLevelUserId}`;
    } else {
      userId = `DONNA-${tenant}-${tenantLevelUserId}`;
    }

    window.userGuiding.identify(userId, {
      name: fullName,
      email,
      created_at: Date.now(),
      aiq_identity_provider: !isSiaaAgency ? "DONNA" : "AgencyIQ",
      ...(tenant && { aiq_tenant: tenant }),
      ...(isSSO && { aiq_company: ssoCompany }),
      ...(isSSO && { aiq_agency_id: ssoAgencyId }),
      ...(isSSO && { aiq_sub: ssoSub }),
      ...(isSSO && { aiq_external_id: ssoExternalId }),
      ...(isSSO && { aiq_email_id: ssoEmailID }),
      ...(isSSO && { aiq_role: ssoRole }),
      isTrial: false,
      numberOfGuides: 3,
    });
  }, [user, tenantApi]);
  return <></>;
}
